import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Header from "components/starshop/exchangeModal/ExchangeHeader";
import PopupBody from "components/starshop/exchangeModal/ExchangeBody";

const EXCHANGABLE_PEDC_LIST = [
    "PEDC-00011",
    "PEDC-00020",
    "PEDC-00021",
    "PEDC-00022",
    "PEDC-00023",
    "PEDC-00024",
    "PEDC-00025",
    "PEDC-00026",
];

const Popup = () => {
    const loginInfo = useSelector((state) => state.loginReducer);
    const pedcCd = useSelector((state) => state.loginReducer.pedcCd);
    const starshopInfo = useSelector((state) => state.starshopReducer);

    const [exchangable, setExchangable] = useState(false);

    const myInfo = {
        userId: loginInfo.userId,
        userNm: loginInfo.mmbrName,
        contractNumber: loginInfo.contractNumber,
        customerNumber: loginInfo.customerNumber,
        authCode: loginInfo.authCode,
    };

    useEffect(() => {
        checkExchangable();
    }, [starshopInfo]);

    const checkExchangable = () => {
        if (
            starshopInfo.mmbrType === "1" &&
            (starshopInfo.schoolStatus === 0 ||
                starshopInfo.schoolStatus === 2 ||
                (starshopInfo.schoolStatus === 1 && EXCHANGABLE_PEDC_LIST.includes(pedcCd))) &&
            pedcCd !== "PEDC-00000" &&
            pedcCd !== "PEDC-00009"
        ) {
            setExchangable(true);
            return;
        }
        setExchangable(false);
    };

    return (
        <>
            <div className="App">
                <Header></Header>
                <PopupBody exchangable={exchangable} myInfo={myInfo} starshopInfo={starshopInfo}></PopupBody>
            </div>
        </>
    );
};

export default Popup;
